export const campaignStyles = {
  label: { fontSize: 14, fontWeight: 600 },
};
